import { render, staticRenderFns } from "./ScheduleLayout.vue?vue&type=template&id=056240d4&scoped=true"
import script from "./ScheduleLayout.vue?vue&type=script&lang=js"
export * from "./ScheduleLayout.vue?vue&type=script&lang=js"
import style0 from "./ScheduleLayout.vue?vue&type=style&index=0&id=056240d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056240d4",
  null
  
)

export default component.exports